var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7556 18.578L14.0682 12.8906C15.1699 11.5298 15.8332 9.8007 15.8332 7.91742C15.8332 3.55253 12.2815 0.000930786 7.91656 0.000930786C3.55161 0.000930786 0 3.55249 0 7.91738C0 12.2823 3.55164 15.8339 7.9166 15.8339C9.7999 15.8339 11.5291 15.1706 12.8899 14.0689L18.5773 19.7563C18.7398 19.9188 18.9531 20.0005 19.1665 20.0005C19.3798 20.0005 19.5932 19.9188 19.7557 19.7563C20.0815 19.4305 20.0815 18.9038 19.7556 18.578ZM7.9166 14.1672C4.46996 14.1672 1.66666 11.364 1.66666 7.91738C1.66666 4.47079 4.46996 1.66753 7.9166 1.66753C11.3632 1.66753 14.1665 4.47079 14.1665 7.91738C14.1665 11.364 11.3632 14.1672 7.9166 14.1672Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.427111921621c1057197a3bfe2f9b8c5.svg";
export { ForwardRef as ReactComponent };